import template from './document.paged-document-preview.html';
import page from './page/documents.page.js';

export default angular
  .module(
    'doxy.realtime.components.teleconsent.action.paged-document-preview',
    [page]
  )
  .component('pagedDocumentPreview', {
    //paged-document-preview
    template,
    bindings: {
      selectedDocument: '<',
      onShare: '&',
    },
    controller: function (tcDataParser) {
      this.$onInit = () => {
        // Ensure selectedDocument and metadata are available before accessing them
        if (!this.selectedDocument || !this.selectedDocument.metadata) {
          console.warn('PagedDocumentPreview: selectedDocument or metadata not available');
          return;
        }

        this.document = { ...this.selectedDocument };
        this.document.data = tcDataParser.parseFields(
          this.document.metadata.fields || {}
        );
        this.document.pages = this.document.metadata.pages;
        this.document.fields = this.document.metadata.fields;

        this.firstPageIndex = 0;
        this.currentPageIndex = this.firstPageIndex;

        this.init();
      };

      this.init = () => {
        if (!this.document || !this.document.pages) {
          console.warn('PagedDocumentPreview: document or pages not available in init');
          return;
        }
        this.lastPageIndex = this.document.pages.length - 1;
      };

      this.nextPage = () => {
        this.currentPageIndex++;
      };

      this.prevPage = () => {
        this.currentPageIndex--;
      };

      this.$onChanges = this.init;
    },
  }).name;
